<template>
    <div>
        <!-- DIALOGO DE LOADING -->
        <Dialog :baseZIndex="2" :visible.sync="loading" :closable="false" :containerStyle="{ width: '300px' }" :modal="true">
            <ProgressBar mode="indeterminate" style="height: 0.5em" />
            <span>{{ loadingMensaje }}</span>
        </Dialog>
        <div class="card">
            <div class="flex justify-content-center flex-wrap card-container">
                <div class="flex align-items-center justify-content-center w-14rem h-4rem m-2">
                    <span class="p-float-label">
                        <Calendar v-model="fechaI" dateFormat="dd-MM-yy" />
                        <label>Fecha Inicial</label>
                      </span>
                </div>
                <div class="flex align-items-center justify-content-center w-14rem h-4rem m-2">
                    <span class="p-float-label">
                        <Calendar v-model="fechaF" dateFormat="dd-MM-yy" />
                        <label>Fecha Final</label>
                      </span>
                </div>
                <div class="flex align-items-center justify-content-center w-4rem h-4rem m-2">
                    <div class="field col-4">
                        <Button icon="mdi mdi-text-box-search-outline" class="p-button-text p-button-rounded" @click="Consultar()" v-tooltip.bottom="'Consultar'" style="color:#FBC31F"/>
                    </div>
                </div>
            </div>
            <!-- TABLA DE INGRESOS POR TIPO DE ORIGEN -->
            <DataTable :value="itemsReporte" :scrollable="true" scrollHeight="600px" scrollDirection="both" :paginator="true" :rows="10" paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            :rowsPerPageOptions="[10,20,50]"
            currentPageReportTemplate="{first} a {last} de {totalRecords}">
                <template #header>
                    <div class="text-center p-d-flex justify-center p-fluid grid formgrid">
                        <div class="col-12 text-center pa-0 ma-0 pl-3">
                            <h1>Origen Recurso</h1>
                            <Button icon="mdi mdi-information" class="p-button-text p-button-rounded" @click="OpenNotas(1)" v-tooltip.bottom="'Información'" style="color:#24ACF2"/>
                        </div>
                    </div>
                </template>
                <Column field="fechaPago" header="Fecha de Pago" :styles="{'flex-grow':'1', 'flex-basis':'150px'}">
                    <template #body="{ data }">
                        <span>{{ formtaDate(data.fechaPago) }}</span>
                      </template>
                </Column>
                <Column field="serie" header="Serie" :styles="{'flex-grow':'1', 'flex-basis':'200px'}"></Column>
                <Column field="folio" header="Folio" :styles="{'flex-grow':'1', 'flex-basis':'200px'}"></Column>
                <Column field="rfc" header="RFC" :styles="{'flex-grow':'1', 'flex-basis':'200px'}"></Column>
                <Column field="nombre" header="Nombre" :styles="{'flex-grow':'1', 'flex-basis':'200px'}"></Column>
                <Column field="origen" header="Origen" :styles="{'flex-grow':'1', 'flex-basis':'200px'}"></Column>
                <Column field="impuestosRetenidos" header="ISR" :styles="{'flex-grow':'1', 'flex-basis':'150px'}">
                    <template #body="{ data }">
                        <span>{{ formatCurrency(data.impuestosRetenidos) }}</span>
                      </template>
                </Column>
                <Column field="tipoNomina" header="Tipo de Nómina" :styles="{'flex-grow':'1', 'flex-basis':'200px'}"></Column>
                <Column field="fechaInicialPago" header="Fecha Inicial de Pago" :styles="{'flex-grow':'1', 'flex-basis':'150px'}">
                    <template #body="{ data }">
                        <span>{{ formtaDate(data.fechaInicialPago) }}</span>
                      </template>
                </Column>
                <Column field="fechaFinalPago" header="Fecha Final de Pago" :styles="{'flex-grow':'1', 'flex-basis':'150px'}">
                    <template #body="{ data }">
                        <span>{{ formtaDate(data.fechaFinalPago) }}</span>
                      </template>
                </Column>
                <Column field="puesto" header="Puesto" :styles="{'flex-grow':'1', 'flex-basis':'200px'}"></Column>
                <Column field="departamento" header="Departamento" :styles="{'flex-grow':'1', 'flex-basis':'200px'}"></Column>
                <Column field="folioFiscal" header="Folio Fiscal" :styles="{'flex-grow':'1', 'flex-basis':'200px'}"></Column>
            </DataTable>
        </div>
    </div>
</template>
<script>
    import axios from 'axios'
    import moment from 'moment'
    import { FilterMatchMode, FilterOperator } from "primevue/api/";

    export default {
        components: {
            
        },
        data() {
            return {
                itemsReporte: [],
                fechaI: new Date(),
                fechaF: new Date(),

                loading: false,
                loadingMensaje: '',
            }
        },
        computed: {
            token() {
                return this.$store.state.usuario;
            },
            
        },
        created() {

        },
        methods: {
            async Consultar(){
                this.loading = true;
                this.loadingMensaje = 'Consultando, espere...'
                let fI = moment(this.fechaI).format('YYYY-MM-DD')
                let fF = moment(this.fechaF).format('YYYY-MM-DD')
                try{
                    let response = await axios.get('ReporteNominas/GetReporteOrigenRecurso/'+ this.token.empresaBase + '/' + fI + '/' + fF);
                    console.log(response.data)
                    this.itemsReporte = response.data;
                    this.loading = false;
                }catch(error){
                    console.log(error)
                    this.loading = false;
                }
            },

            formatCurrency(value) {
                return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
            },

            formtaDate(value){
                return moment(value).format('DD-MM-YYYY')
            },

        },
    }
</script>